import Page from "../../finwell/pages/Page";
import Loader from "../../components/Loader/Loader";
import { useEffect, useState } from "react";
import CodeOfEthicsReportHomeSection from "../../components/Reports/codeOfEthics/CodeOfEthicsReportHomeSection";
import CONFIG from "../../utils/config";

export const CodeOfEthicsReportPageMobile = () => {
    const [isLoading, setIsLoading] = useState(false);
    useEffect(() => {
        window.scrollTo(0, 0);
            if (document.getElementById("id_page_404") !== null) {
              document.getElementById("id_page_404").style.display = "none";
            }
        setTimeout(() => {
            if (document.getElementById("cc_div") !== null)
              document.getElementById("cc_div").style.display = "none";
          }, 100)
    }, [])

    useEffect(() => {
        window.scrollTo(0, 0);

        let sendHeight = setInterval(() => {
            let obj = { 'method': 'height', 'value': document.getElementById("root").scrollHeight }
            console.log('height: ', obj);
            window.parent.postMessage(obj, "*");
        }, 3000)

        return (() => { clearInterval(sendHeight) })
    }, [])
    return (
        <>
            <Loader start={isLoading} />
            <div className="container pb-2rem">
            <CodeOfEthicsReportHomeSection
                setIsLoading={setIsLoading}
                isLoading={isLoading}
                isMobile={true}
            />
            </div>
        </>
    )
}

export default CodeOfEthicsReportPageMobile;